import React from "react";

export const WiFi = ({ color, size, info }) => (
	<svg width='20' height='100%' className="mr-1 inline-block" viewBox="0 0 27.6 25.4">
		<path className="st0" d="m13.2 23.3c-0.8 0-1.5-0.7-1.5-1.5 0-4-3.4-7.2-7.7-7.2-0.8 0-1.5-0.7-1.5-1.5s0.7-1.5 1.5-1.5c5.9 0 10.7 4.6 10.7 10.2 0 0.8-0.7 1.5-1.5 1.5z" />
		<path className="st0" d="m19.1 24.8c-0.8 0-1.5-0.7-1.5-1.5 0-8-6.9-14.5-15.4-14.5-0.8 0-1.5-0.7-1.5-1.5s0.7-1.5 1.5-1.5c10.1 0 18.4 7.8 18.4 17.5 0 0.8-0.6 1.5-1.5 1.5z" />
		<path className="st0" d="m24.8 25.3c-0.8 0-1.5-0.7-1.5-1.5 0-11.3-9.8-20.5-21.8-20.5-0.8 0-1.5-0.7-1.5-1.5s0.7-1.5 1.5-1.5c13.7 0 24.8 10.5 24.8 23.5 0 0.8-0.6 1.5-1.5 1.5z" />
		<circle  className="st0" cx="5.6" cy="20.3" r="2.2" />
	</svg>
)